module.exports = __webpack_public_path__ + "img/owl.0d0303c3.svg";